import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MachineTabIcon, MyDashBoardIcon, SiteTabIcon } from "../../assets/Icons";
import SimulanisIcon from "../../assets/images/favicon.png";
import { useSelector } from "react-redux";

const SideBarV2 = ({ sideBar, setSideBar }) => {
  const userData = useSelector((state) => state.userSlice);
  const userGroupId = userData?.user?.group?.uuid;
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("machine");

  useEffect(() => {
    const path = location.pathname;
    let active = "machine";
    if (path.startsWith("/dashboard")) active = "dashboard";
    else if (path.startsWith("/machines") || path.startsWith("/machine-list")) active = "machines";
    else if (path.startsWith("/s/dashboard")) active = "siteDashBoard";
    else if (path.startsWith("/site")) active = "site";
    setActiveTab(active);
  }, [location.pathname]);

  const handleClick = (path) => navigate(path);

  return (
    <div className="mainside portal-v2-sidebar-wrap">
      <div className={sideBar ? "sidmenu active portal-v2-sidebar" : "sidmenu portal-v2-sidebar"}>
        <div className="mainsidelist portal-v2-sidebar__nav">
          <ul>
            {userData?.user?.permissions?.includes("MACHINE.DASHBOARD") && (
              <li
                className={activeTab === "dashboard" ? "active" : ""}
                onClick={() => handleClick(`/dashboard/${userGroupId}`)}
              >
                <MyDashBoardIcon />
                <p className="ms-3">Dashboard</p>
              </li>
            )}
            {userData?.user?.permissions?.includes("MACHINE.VIEW") && (
              <li
                className={activeTab === "machines" || activeTab === "machine" ? "active" : ""}
                onClick={() => handleClick(`/machine-list/view/${userGroupId}`)}
              >
                <MachineTabIcon />
                <p className="ms-3">Machines</p>
              </li>
            )}
            {userData?.user?.permissions?.includes("MACHINE.VIEW") && (
              <li
                className={activeTab === "site" ? "active" : ""}
                onClick={() => handleClick(`/site-list/view/${userGroupId}`)}
              >
                <SiteTabIcon />
                <p className="ms-3">Sites</p>
              </li>
            )}
            {userData?.user?.permissions?.includes("MACHINE.VIEW") && (
              <li
                className={activeTab === "siteDashBoard" ? "active" : ""}
                onClick={() => handleClick(`/s/dashboard/${userGroupId}`)}
              >
                <MyDashBoardIcon />
                <p className="ms-3">Site Dashboard</p>
              </li>
            )}
          </ul>
        </div>
        <div className="portal-v2-sidebar__footer">
          <div className="portal-v2-status-card">
            <span className="portal-v2-status-card__dot" />
            <div>
              <strong>System Status</strong>
              <p>All systems operational</p>
            </div>
          </div>
          <p className="pwrdby portal-v2-powered">
            Powered by{" "}
            <strong>
              <img src={SimulanisIcon} alt="" />
              <span>Simulanis</span>
            </strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SideBarV2;
